
import React, {useState, useEffect, useRef, useCallback} from 'react';
import { Avatar, Grid, Paper, FormControlLabel, Switch, Typography, Button, Box, TextField } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useFileUpload } from 'core/hooks/useFileUpload';
import { useSnackbar } from 'notistack';
import { useForm, Controller } from "react-hook-form";
import { uploadProfilePhoto } from 'core/services/profile';

const AccountLogo = ({accountDetails, profilePhoto}) => {
  const defaultFormValues = {image: ''};
  const { active = false, name, email = '', mobile = '' } = accountDetails;
  const [profileImage, setProfileImage] = useState(profilePhoto);
  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control, } = useForm({
    defaultValues: {...defaultFormValues}
  });
  const [fileInput, setFileInput] = useState();
  const fileUploadInutRef = useRef(null);

  const [uploadPhoto] = useFileUpload({
		onStarting: (file) => {
      setFileInput(file);
			var reader = new FileReader();
			reader.readAsDataURL(file)
			reader.onloadend = () => setProfileImage(reader.result);
		}
  });

  useEffect(() => {
    setProfileImage(profilePhoto);
  }, [profilePhoto]);

  const onSubmit = () => {
    const postData = {
      image: fileInput
    };
    uploadProfilePhoto(postData).then(({response, error}) => {
      if(error){
        enqueueSnackbar((response?.message || 'Failed to upload profile photo'), {variant: 'error'});
      }else{
        setFileInput(null);
      }
    });
  };

  const cancelUpload = () => {
    setFileInput(null);
    setProfileImage(profilePhoto);
  };

  const onProfilePhotoClick = useCallback(() => {
    if(fileUploadInutRef?.current?.click){
      fileUploadInutRef.current.click();
    }
  },[fileUploadInutRef],);
  
  return (
    <Paper  sx={{py: 6, px: 3, boxShadow: 'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px'}}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        { profilePhoto ? (
          <Avatar variant="square" src={profileImage} sx={{ width: 200, height: 200, cursor: 'pointer' }} onClick={onProfilePhotoClick} /> 
        ) : <Avatar variant="square" sx={{ width: 200, height: 200, cursor: 'pointer'}} >
          <AccountCircleIcon sx={{ fontSize: 150 }} onClick={onProfilePhotoClick} />
        </Avatar>}
      </Grid>
      <Grid container direction="row" justifyContent="center" alignItems="center" sx={{my: 1, p: 1}}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{textAlign: "center"}} >
          <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1,  }}>
            <Box sx={{visibility: 'hidden', width: 0, height: 0}}>
              <Controller
                control={control}
                name="image"
                id="image"
                render={({field }) => (
                    <TextField
                      {...field}
                      margin="normal"
                      type="file"
                      fullWidth
                      required
                      onChange={(e) => {uploadPhoto(e); return true;}}
                      inputRef={fileUploadInutRef}
                    />
                )}
              />
            </Box>
            {fileInput ? (
              <>
                <Button onClick={cancelUpload} variant="contained" color="info" size="medium" sx={{m: 1}}>Cancle</Button> 
                <Button type="submit" variant="contained" color="success" size="medium" sx={{m: 1}}>Upload</Button> 
              </>
            ): null}
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography variant="h6" component="p" sx={{mt: 3}}>
            {name}
          </Typography>
        </Grid>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography  component="p">
            {mobile}
          </Typography>
        </Grid>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography variant="caption"  sx={{mt: 1}}>
              {email}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{mt: 4}}
      >
        <FormControlLabel disabled control={<Switch checked={active} color="success" />} label="Active" labelPlacement="start" />
      </Grid>
    </Paper>
  );
}
 
export default AccountLogo;
